import React from "react";
import { Header } from "semantic-ui-react";

const content = {
  title: "Annuaire de CentraleSupélec",
  texte: (
    <div>
      <Header as="h3" textAlign="center">
        <Header.Content>
          Bienvenue sur l'annuaire de CentraleSupélec !
        </Header.Content>
      </Header>
      <p>
        Ici vous pouvez rechercher membres de l'administration, professeurs et
        élèves.
        <br />
        La recherche se fait par nom et/ou prénom.
      </p>
    </div>
  )
};

export default content;



// WEBPACK FOOTER //
// ./src/scenes/HomePage/content.js